import styled from 'styled-components';

const Container = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 50px;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
`;

const DomainNameContainer = styled.div`
  width: 150px;
`;

const DownloadButtonContainer = styled.div`
  margin-left: 20px;
  margin-top: 20px;
  position: relative;
`;

const DownloadIconContainer = styled.div`
  margin-left: 10px;
`;

const CompanyInputContainer = styled.div`
  width: 300px;

  label {
    font-size: 1em;
  }

  input {
    font-size: 1.2em;
  }
`;

const LogoUploadButtonContainer = styled.div`
  height: 100%;
  width: 100%;

  input {
    width: 150px;
    margin-right: 10px;
  }
`;

const LogoUploadContainer = styled.div`
  flex-direction: column;
`;

const LogoContainer = styled.div`
  img {
    height: 100px;
  }
`;

const Row = styled.div`
  padding: 20px 0;
  width: 100%;
  display: flex;
`;

const Left = styled.div`
  padding-right: 50px;
  width: 50%;
  display: flex;
  flex-direction: column;
`;

const Right = styled.div`
  padding-left: 50px;
  width: 50%;
  display: flex;
  justify-content: flex-start;
`;

const Spacer = styled.div`
  height: 10px;
`;

const InvoiceInputContainer = styled.div``;
const PaymentReceiptInputContainer = styled.div``;
const PaymentSelectionContainer = styled.div``;
const PaymentPlanContainer = styled.div``;

const TrialContainer = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
`;

const PaymentModeContainer = styled.div``;

const FinalizeButtonContainer = styled.div`
  width: 100%;
  margin-top: 30px;
  display: flex;
  flex-direction: row;
`;

const ExpireButtonContainer = styled.div`
  width: 100px;
  position: relative;
`;

const SubmitButtonContainer = styled.div`
  margin-left: 50px;
  flex: 1;
  position: relative;
`;

const Loader = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SnackbarMessage = styled.span``;

const BlockButtonContainer = styled.div`
  width: 200px;
  margin-top: 80px;
  position: relative;
`;

const PlanDuration = styled.div`
  flex-direction: row;
`;

const PresetDurations = styled.div`
  flex-direction: column;
  margin-top: 20px;
`;

const PresetDuration = styled.div`
  flex-direction: row;
  margin-top: 10px;
`;

const StartDatePicker = styled.div`
`;

const ExpiryDatePicker = styled.div`
  margin-top: 20px;
`;

export default {
  Container,
  Header,
  CompanyInputContainer,
  DownloadButtonContainer,
  DownloadIconContainer,
  Row,
  Left,
  Right,
  Spacer,
  InvoiceInputContainer,
  PaymentReceiptInputContainer,
  PaymentSelectionContainer,
  PaymentPlanContainer,
  TrialContainer,
  PaymentModeContainer,
  DomainNameContainer,
  FinalizeButtonContainer,
  ExpireButtonContainer,
  SubmitButtonContainer,
  Loader,
  SnackbarMessage,
  BlockButtonContainer,
  LogoUploadButtonContainer,
  LogoContainer,
  LogoUploadContainer,
  PlanDuration,
  PresetDurations,
  PresetDuration,
  StartDatePicker,
  ExpiryDatePicker
};



// WEBPACK FOOTER //
// ./src/pages/PayCompany/styles.js